enum EOrganizationType {
  Tenant = 'type1',
  Company = 'type2',
}

export default EOrganizationType;
